(function($) {
  var isIE =  (typeof document.createElement("span").dragDrop === "function");

  var detectLeftButton = PegasusTemplate.Helpers.detectLeftButtonDepressed;

  $.fn.customDragImage = function(options) {
    var offsetX = options.offsetX || 0,
      offsetY = options.offsetY || 0;

    var createDragImage = function($node, x, y) {
      var $img = $(options.createDragImage($node));
      $img.css({
        zIndex: 999999,
        top: Math.max(0, y-offsetY)+"px",
        left: Math.max(0, x-offsetX)+"px",
        position: "fixed",
        pointerEvents: "none"
      }).appendTo(document.body);

      setTimeout(function() {
        $img.remove();
      });

      return $img[0];
    };

    if (isIE) {
      $(this).off("mousemove.drag").on("mousemove.drag", function(e) {
        // don't drag if we are trying to select text in a ckeditor instance
        if ( $(e.target).closest('.cke_editable').length ) { return; }

        if ( detectLeftButton(e) ) {
          var originalEvent = e.originalEvent,
            node = createDragImage($(this), originalEvent.pageX, originalEvent.pageY);

          node.dragDrop();
        }
      });
    }

    $(this).off("dragstart.drag").on("dragstart.drag", function(e) {
      var originalEvent = e.originalEvent,
        dt = originalEvent.dataTransfer;

      dt.setData('text', 'some');

      if (typeof dt.setDragImage === "function") {
        node = createDragImage($(this), originalEvent.pageX, originalEvent.pageY);
        dt.setDragImage(node, offsetX, offsetY);
      }
    });

    return this;
  };
})(jQuery);

window.vrDragging = null;
window.vrDraggingRowIndex = null;

(function(){
  var instance;
  var originalOpacity;
  var command;

  PegasusTemplate.DragManager = Em.Controller.extend({
    handleDragStart: function(e){
      var source = e.target,
        sourceView,
        cookie;

      if ( $(source).closest('.select-operations').length ) {
        source = PegasusTemplate.lookupController('blockOperations').get('row.element');
      }

      // if we are editing content in the row we're trying to drag
      //if ( PegasusTemplate.lookupController('rowOperations').get('content').$('.editing').length ) {
        //PegasusTemplate.stateMachine.send('didFinishEditing');
        //return false;
      //}

      Em.run.scheduleOnce('afterRender', this, function(){
        PegasusTemplate.lookupController('blockOperations').set('content', null);
        PegasusTemplate.lookupController('rowOperations').set('content', null);
      });

      if ( ! source || ! source.draggable ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      originalOpacity = source.style.opacity ? source.style.opacity : 1.0;

      sourceView = Em.View.views[source.id || source.dataset.id];
      vrDragging = source;
      currentIndex = PegasusTemplate.blockRegionInstance.indexOf( sourceView );
      vrDraggingRowIndex = currentIndex;
      cookie = sourceView.mutateForOut(null, true).editor_cookie;

      e.dataTransfer.effectAllowed = 'move';

      var callback = function(){
        //debugger;
      };

      command = PegasusTemplate.MoveRowCommand.extend({
        klass: sourceView.constructor,
        backup: cookie,
        sourceElement: cookie,
        callback: callback.bind(this),
        childPosition: currentIndex
      });

      source.style.opacity = 0.4;
    },

    handleDragEnd: function(e){
      vrDragging.style.opacity = originalOpacity;
      Em.run.scheduleOnce('afterRender', this, function(){
        PegasusTemplate.lookupController('activePortionControl').set('row', null);
      });
      $('.vr-row-target-above,.vr-row-target-below').
        removeClass('vr-row-target-above').
        removeClass('vr-row-target-below');
    },

    handleDragOver: function(e) {
      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }

      e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

      return false;
    },

    handleDrop: function (e) {
      var isAddition = false;
      var destination;

      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }

      if (e.preventDefault) {
        e.preventDefault(); // Stops some browsers from redirecting.
      }

      var block = PegasusTemplate.lookupStore().all(PegasusTemplate.Block).filterProperty('name', e.dataTransfer.getData("text") ).get('firstObject');
      var needsTemplateSpec = false;
      if ( block ) {
        isAddition = true;
        cookie = block.get('html').replace(/{SERVER_URL}/g, PegasusTemplate.get('templateAssetHost'));
        command = PegasusTemplate.AddRowCommand.extend({
          klass: PegasusTemplate.loadedTemplate().rowClass(),
          needsScroll: false,
          sourceElement: cookie
        });

        if ( block.get('intrinsic_width') > PegasusTemplate.lookupController('toolbar').get('selectedTemplateWidth') ) {
          needsTemplateSpec = true;
        }
      }

      if ( !vrDragging && !isAddition ) {
        return false;
      }


      $('.vr-row-target-above,.vr-row-target-below').
        removeClass('vr-row-target-above').
        removeClass('vr-row-target-below');

      var targetView = PegasusTemplate.lookupController('activePortionControl').get('row');
      var activePortion = PegasusTemplate.lookupController('activePortionControl').get('active');

      //if ( !targetView ) {
        //return false;
      //}

      PegasusTemplate.lookupController('activePortionControl').set('row', null);

      var isTopDrop = activePortion === 'top';
      var isBottomDrop = activePortion === 'bottom';

      var targetIndex = PegasusTemplate.blockRegionInstance.indexOf(targetView);
      var maxIndex = PegasusTemplate.blockRegionInstance.get('length') - 1;

      if ( isAddition ) {

        if ( isTopDrop ) {
          destination = targetIndex;
        } else if ( isBottomDrop )  {
          destination = targetIndex + 1;
        } else {
          if ( e.target.classList.contains('vr-no-rows') || $(e.target).closest('.vr-no-rows').length ) {
            destination = 0;
          } else {
            return false;
          }
        }

      } else if( vrDragging && targetView ) {

        // Don't do anything if dropping the same column we're dragging.
        if ( (vrDragging.id != targetView.get('elementId')) || (PegasusTemplate.blockRegionInstance.get('length') === 0 ) ) {
          if ( isTopDrop ) {
            if ( targetIndex < vrDraggingRowIndex ) {
              destination = targetIndex;
            } else {
              destination = targetIndex - 1;
            }
          } else {
            if ( targetIndex > vrDraggingRowIndex ) {
              destination = targetIndex;
            } else {
              destination = targetIndex + 1;
            }
          }

          if ( destination < 0 ) {
            destination = 0;
          }

          if ( destination > maxIndex ) {
            destination = maxIndex;
          }
        }

      }

      if ( destination >= 0 ) {
        PegasusTemplate.stateMachine.send('didFinishEditing');

        command = command.create({
          desiredPosition: destination
        });

        Em.run.scheduleOnce('afterRender', command, 'execute');
        if ( needsTemplateSpec ) {
          Em.run.scheduleOnce(
            'afterRender',
            PegasusTemplate.lookupController('frameCommManager'),
            'send',
            'requestIntrinsicWidthBreach', {
              intrinsicTemplateWidth: block.get('intrinsic_width'),
              electedTemplateWidth: PegasusTemplate.lookupController('toolbar').get('selectedTemplateWidth')
            }
          );
        }
      }

      return false;
    },

    handleDragEnter: function (e) {
      var row = $(e.target).closest('.vr-row');
      var apcController = PegasusTemplate.lookupController('activePortionControl');

      if ( row.length ) {
        row = Em.View.views[ row[0].id ];
        apcController.set('row', row);
      }
      // future story
    },

    handleDragLeave: function (e) {
      // future story
    },

    init: function(){
      this._super();

      window.addEventListener('dragstart', this.handleDragStart, false);
      window.addEventListener('dragenter', this.handleDragEnter, false)
      window.addEventListener('dragover', this.handleDragOver, false);
      window.addEventListener('dragleave', this.handleDragLeave, false);
      window.addEventListener('drop', this.handleDrop, false);
      window.addEventListener('dragend', this.handleDragEnd, false);
    }
  });

  PegasusTemplate.DragManager.reopenClass({
    create: function(){
      if ( instance ) {
        return instance;
      }
      var result = this._super.apply(this, arguments);
      instance = result;

      return instance;
    },
    getInstance: function(){
      return PegasusTemplate.DragManager.create();
    }
  });
})();

PegasusTemplate.DragManager.getInstance();
